/**
 * Identifiers are minted on the device, offline, and must never collide with one minted on
 * another device for the same household.
 *
 * `crypto.randomUUID` is deliberately not used: React Native has no such thing, and the
 * usual polyfill (react-native-get-random-values) supplies only `getRandomValues`. Building
 * on that one primitive means the same code path runs on web, in a Worker, and on a phone.
 */
export function randomId(): string {
  const bytes = new Uint8Array(16);
  crypto.getRandomValues(bytes);

  let out = '';
  for (const byte of bytes) out += byte.toString(16).padStart(2, '0');
  return out;
}
